<p8-bdc-images [selectingMode]="true" (imageSelected)="imageSelected($event)"></p8-bdc-images>
